import { headerMenuAtom } from "@app/shared/atoms";
import { useIsMobile } from "@core/shared/hooks";
import { URLS } from "@core/shared/utils";
import { platformFeaturesAtom } from "@framework/shared/atoms";
import { trans } from "@mongez/localization";
import { useLocation } from "@remix-run/react";
import { GraduationCap, Home, Key, LayoutList, Menu } from "lucide-react";
import type { ElementType } from "react";
import { unlockCodePortal } from "../atoms/unlock-code.atom";

export type BottomNavigationItem = {
  icon: ElementType;
  label: string;
  to?: string;
  onClick?: () => void;
  isActive?: boolean;
};

export function useBottomNavigation() {
  const isMobile = useIsMobile();
  const location = useLocation();
  const platformFeatures = platformFeaturesAtom.useValue();

  const items = [
    {
      icon: Menu,
      label: trans("menu"),
      onClick: headerMenuAtom.open,
    },
    {
      icon: Home,
      label: trans("home.title"),
      to: URLS.home,
      isActive: location.pathname === URLS.home,
    },
    platformFeatures.socialFeed === true && {
      icon: LayoutList,
      label: trans("home.feed"),
      to: URLS.feed,
      isActive: location.pathname.startsWith(URLS.feed),
    },
    {
      icon: GraduationCap,
      label: trans("grades.lessons"),
      to: URLS.lessons.list,
      isActive: location.pathname.startsWith(URLS.lessons.list),
    },
    {
      icon: Key,
      label: trans("unlockCode.code"),
      onClick: unlockCodePortal.open,
    },
  ].filter(Boolean) as BottomNavigationItem[];

  return {
    isMobile,
    items,
  };
}
